<template>
  <main class="pt-18 md:pt-[12.5vw] lg:pt-[5vw] bg-white">

    <section class="py-9 md:py-18 relative overflow-hidden">
      <div class="container-1">

        <div class="lg:flex items-center gap-4">
          <div class="w-auto lg:w-1/2">
            <div class="lg:max-w-[34vw] space-y-12 lg:space-y-6">
              <div class="text-ip-color-3 space-y-2" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
                <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-ip-color-10 rounded-md w-fit p-[.38rem]">About Us</div>
                <div class="text-2xl leading-tight md:text-[2.4vw] md:leading-[2.8vw] lg:text-[1.8vw] lg:leading-[2.6vw] font-semibold figtree">
                  ImpacThink is your trusted partner in sustainable transformation.
                </div>
              </div>
              <div class="lg:hidden"
                data-aos="fade-right" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200"
              >
                <figure class="rounded-3xl overflow-clip -mr-14 md:-mr-[7.292vw] lg:-mr-[2.917vw]">
                  <img src="/images/about-us/bg-about.webp" format="webp" alt="" class="w-full h-full object-cover">
                </figure>
              </div>
              <div class="space-y-6"
                data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200"
              >
                <div class="figtree text-base leading-[24px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1vw] lg:leading-[1.8vw]">
                  ImpacThink is on a mission to transform sustainability communication.
As a forward-thinking consulting firm, we offer a creative and holistic approach to ESG solutions. Our team of experts crafts tailored strategies that not only elevate your sustainability outcomes but also foster meaningful connections with stakeholders. From program implementers to media channels, we ensure your sustainability message resonates, driving impactful and <br class="md:hidden">lasting change.
                </div>
              </div>
            </div>
          </div>

          <div class="hidden lg:block lg:w-1/2">
            <figure class="rounded-3xl overflow-clip -mr-14"
              data-aos="fade-left" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200"
            >
              <img src="/images/about-us/bg-about.webp" format="webp" alt="" class="w-full h-full object-cover">
            </figure>
          </div>
        </div>

      </div>
    </section>

    <section class="py-14 md:py-28 bg-ip-color-8 relative">
      <div class="container-1 space-y-12 lg:space-y-16">

        <div class="text-ip-color-3 space-y-2" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
          <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-ip-color-10 rounded-md w-fit p-[.38rem]">Our Advantages</div>
          <div class="text-2xl leading-tight md:text-[2.4vw] md:leading-[2.8vw] lg:text-[1.8vw] lg:leading-[2.6vw] font-semibold figtree">
            Unleashing your potential with our unique advantages
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-20">
          <div v-for="(item, i) in advantageDetail" :key="item.id" class="space-y-6"
            data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" :data-aos-delay="`${600+(i*100)}`"
          >
            <div class="flex items-center gap-3">
              <figure class="max-w-6">
                <VectorSingleArrow color="ip-color-10" />
              </figure>
              <div class="figtree text-xl md:text-[2.6vw] lg:text-[1.4vw] text-ip-color-3 font-semibold">{{ item.name }}</div>
            </div>
            <ul class="list-disc space-y-4 pl-12 md:pl-[3.6vw]">
              <li v-for="(item, i) in item.points" :key="i" class="figtree font-medium text-base leading-[24px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw]">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

        <NuxtLink
          :to="({name: 'our-services'})"
          data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200"
          class="figtree group rounded-3xl h-full py-2 px-3 lg:py-3 lg:px-6 w-fit hover:bg-ip-color-2 bg-ip-color-12 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] hover:text-ip-color-3 text-white flex items-center gap-1 transition-colors duration-300">
            Our Services
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
              <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
            </svg>
        </NuxtLink>

      </div>
    </section>

    <section class="py-14 md:py-28 bg-ip-color-11 relative">
      <div class="container-1 space-y-12 md:space-y-16">
        <TeamExperts/>
      </div>
    </section>
  </main>
</template>

<script setup>
import { Interactions } from '../../interactions';
const route = useRoute();
const router = useRouter();
 
 
 
const lang = ref('en')
const isMediumScreen = useMediaQuery('(min-width: 768px)');
const isLargeScreen = useMediaQuery('(min-width: 1024px)');
const ready = ref(false);

useSeoMeta({
  ogUrl: 'https://impacthink.id/about-us',
  title: 'About Us - ImpacThink',
  ogTitle: 'About Us - ImpacThink',
  twitterTitle: 'About Us - ImpacThink',
  description: 'ImpacThink is your trusted partner in sustainable transformation',
  ogDescription: 'ImpacThink is your trusted partner in sustainable transformation',
  twitterDescription: 'ImpacThink is your trusted partner in sustainable transformation',
  ogType: 'website',
  ogImage: '/seo-image.webp',
  twitterImage: '/seo-image.webp',
  twitterCard: 'summary',
});

definePageMeta({
  layout: 'home-layout',
});

const { $refreshAos } = useNuxtApp();
const emits = defineEmits(['onLoaded']);
const dayjs = useDayjs();
const interactionsVar = new Interactions();

const advantageDetail = ref([
  {
    id: 0,
    name: 'Tech-enhanced Solution',
    points: [
      'Excel in crafting and implementing effective stakeholder strategies.',
      'Combine newest technology with cohesive integrated communication strategies.',
      'Long-standing experiences in creative communication strategy and execution.',
    ],
  },

  {
    id: 1,
    name: 'Trusted Professionals',
    points: [
      'Diverse team of certified sustainability experts from various fields.',
      'Specialists in GRI-compliant sustainability reporting.',
    ],
  },

  {
    id: 2,
    name: 'Boundless Connections',
    points: [
      'Leveraging community power to engage diverse stakeholders.',
      'Partnerships with NGOs and media for broader impact.',
    ],
  },
]);

const scrollPos = ref(0);
const scrollDirection = ref(1);
// const lenisProgress = ref();
const startLenis = () => {
  if (interactionsVar) {
    interactionsVar.createSmoothScroll();
    interactionsVar.startLenis();
    interactionsVar.lenis.on('scroll', (e) => {
      scrollPos.value = e.scroll;
      scrollDirection.value = e.direction;
      // lenisProgress.value.style.width = (e.progress * 100) + '%';
      if (scrollDirection.value < 0) {
        navbarStore.showNavbarValue();
      } else {
        navbarStore.hideNavbarValue();
      }
    });
  }
};

const destroyLenis = () => {
  if (interactionsVar) interactionsVar.destroyLenis();
};

onMounted(() => {
  navbarStore.closeTeamDetail();
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);

  nextTick(() => {
    $refreshAos();
    startLenis();
  });
});

onBeforeUnmount(() => {
  destroyLenis();
});

const navbarStore = useNavbarStore();
const { showSideBar, showContact, showTeamDetail } = storeToRefs(navbarStore);
watch(() => showSideBar.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
watch(() => showContact.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
watch(() => showTeamDetail.value,
  (val) => {
    if (val) {
      interactionsVar.lenis.stop();
    } else {
      interactionsVar.lenis.start();
    }
  },
);
</script>
